import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Group } from '../../types/group';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';
import GroupFYIDocsIntegration from './integrations/fyi-docs/GroupFYIDocsIntegrations';
import IntegrationCard from '../../components/integration-card/IntegrationCard';
import FYILogo from '../../assets/fyi.png';

type GroupIntegrationsProps = {
    group: Group;
};

function GroupIntegrations({ group }: GroupIntegrationsProps): JSX.Element {
    const [searchParams, setSearchParams] = useSearchParams();
    const [focusedIntegration, setFocusedIntegration] = useState<string | undefined>(searchParams.get('focusedIntegration') || undefined);

    function handleIntegrationClick(id: string): void {
        setFocusedIntegration(id);
        setSearchParams((prev) => {
            prev.set('focusedIntegration', id);
            return prev;
        });
    }

    function resetFocusedIntegration(): void {
        setFocusedIntegration(undefined);
        setSearchParams((prev) => {
            prev.delete('focusedIntegration');
            return prev;
        });
    }

    return (
        <div>
            {focusedIntegration === undefined && (
                <div className="flex flex-wrap gap-4">
                    <IntegrationCard
                        id="fyi"
                        title="FYI"
                        description="Pull your documents, clients and groups from FYI."
                        logo={FYILogo}
                        status={group.integrations.fyi ? 'CONNECTED' : 'DEFAULT'}
                        onConfigure={handleIntegrationClick}
                        beta
                    />
                </div>
            )}
            {focusedIntegration !== undefined && (
                <div>
                    <button className="text-sm text-gray-600 flex items-center gap-1 mb-8" onClick={resetFocusedIntegration}>
                        <ChevronLeftIcon className="h-4 w-4" />
                        Integrations
                    </button>
                    {focusedIntegration === 'fyi' && <GroupFYIDocsIntegration group={group} />}
                </div>
            )}
        </div>
    );
}

export default GroupIntegrations;
